import React from "react";

import {
  Form,
  Select,
  Collapse,
  Button,
  Table,
  Space,
  Input,
  Statistic,
  Row,
  Col,
  Name,
} from "antd";

const { Option } = Select;
const { Panel } = Collapse;

class StatisticsUI1 extends React.Component {
  render() {
    const { statisticsData2, name } = this.props;
    return (
      <div>
        <Collapse defaultActiveKey={["2_1"]} expandIconPosition="end">
          <Panel header={name} key="2_1">
            {statisticsData2 ? (
              <Row justify="center" align="top" gutter={[16, 16]}>
                {statisticsData2.map((d) => (
                  <Col span={4} key={d.app}>
                    <div
                      style={{
                        textAlign: "center",
                        padding: "10px",
                        border: "1px solid #adc6ff",
                        backgroundColor: "#f0f5ff",
                      }}
                    >
                      <div>{d.app}</div>
                      <div style={{ fontSize: "26px" }}>{d.count}</div>
                    </div>
                  </Col>
                ))}
              </Row>
            ) : null}
          </Panel>
        </Collapse>
      </div>
    );
  }
}

export default StatisticsUI1;
